import React, { useEffect, useState } from "react";
import "./committee.scss";
import Header from "../header/header";
import HeaderImageSection from "../shared/headerImageSection";
import FooterComponent from "../footerComponent/footerComponent";
import dadaImg from "../../assets/Dada.png";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import committeeProfileImg from "../../assets/committeeProfileImg.png";
import CallIcon from "../../assets/footer/phone.svg";
import axios from "axios";
import { API_URL } from "../../variables";

const Committee = () => {
  const [membersInfo, setMembersInfo] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getCommitteeMemberDetails();
  }, []);

  const getCommitteeMemberDetails = async () => {
    let res = await axios.get(API_URL + "committee_members");
    if (res?.data?.body.length > 0) {
      setMembersInfo(res?.data?.body);
    }
  };
  return (
    <>
      <Header />
      <HeaderImageSection />
      <section className="d-flex align-items-center justify-content-center">
        <div className="row sectionCenter">
          <div className="col-sm-12 col-md-3 d-flex justify-content-center align-items-center text-white flex-column text-center">
            <img src={dadaImg} alt="" />
            <div className="nameSection text-left">
              <label className="font24px m-0">Mr. Satish Dada Darekar</label>
              <label className="font16px m-0">
                Founder, Pune - Maharashtra
              </label>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 d-flex justify-content-start align-items-cleft flex-column">
            <h3 className="mb-2 pl-2 pr-2 font22px textDarkRed pt-5 desktopView">
              Our Vision towards digitalization
            </h3>
            <h3 className="mb-2 pl-2 pr-2 font22px textDarkRed phoneView">
              Our Vision towards digitalization
            </h3>
            <p className="mb-2 pl-2 pr-2">
              At Kumbhar Mangalam, our mission is to honor the rich traditions
              of the Kumbhar community while harnessing the power of digital
              innovation.
            </p>
            <p className="mb-2 pl-2 pr-2">
              We aim to create a user-friendly platform that connects grooms,
              brides, and divorced candidates fostering meaningful relationships
              rootes in our cultural values
            </p>
          </div>
          <div className="col-sm-12 col-md-3 d-flex justify-content-center align-items-center">
            <div className="p-2 w-100 desktopView">
              <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                <PlayCircleIcon className="playIcon" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="d-flex align-items-center justify-content-center">
        <div className="accordianDetails p-3 text-center committeeSection">
          <label className="headerLabel pl-3 mb-3">Our Committee</label>
          <div className="row">
            {membersInfo.map((item, index) => {
              return (
                <div className="col-md-2" key={index}>
                  <div className="committeeMemberInfo">
                    <div className="committeeMemberPhoto">
                      <img src={item.image ? `data:image/jpeg;base64,${item.image}` : committeeProfileImg} alt="" />
                    </div>
                    <div className="committeeMemberDetails">
                      <p className="name mb-0 font-bold text-capitalize">
                        {item.name}
                      </p>
                      <p className="designation mb-0 text-capitalize">
                        {item.designation}, {item.region}
                      </p>
                      <p>
                        <img
                          alt=""
                          src={CallIcon}
                          className="d-inline-block mr-2"
                        />
                        {item.mobile}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <FooterComponent />
    </>
  );
};
export default Committee;
